import React, { useState } from "react";
import { BmModal, Btn } from "../../ForBrands/ui/BrandUI";
import { InfoDot } from "./profileSections";
import { CONTEXT_ACTION, METRIC_INFO, metricInfoLabel } from "./metricDescriptions";

// A profile metric's long description (metricDescriptions.js): the metric's
// title, the long text, then its labelled entries (the three pillars, the
// rate card's deliverables). BmModal does the rest: a centred dialog on
// desktop and a bottom sheet in the phone theme, focus moved in and handed
// back to the (i), Escape and the backdrop close it. `onContext` (the
// CacheValue card, on a profile with a CacheValue in context the page can
// open) adds the "See CacheValue in context" action, which closes this one
// first.
export const MetricInfoDialog = ({ metric, onClose, onContext }) => {
  const info = METRIC_INFO[metric];
  if (!info) return null;
  const footer = onContext ? (
    <Btn
      className="ml-auto"
      onClick={() => {
        onClose();
        onContext();
      }}
    >
      {CONTEXT_ACTION}
    </Btn>
  ) : null;
  return (
    <BmModal title={info.title} onClose={onClose} width={520} footer={footer}>
      <div className="flex flex-col gap-4">
        {info.long && <p className="bm-body-m text-bm-muted">{info.long}</p>}
        {info.entries && (
          <dl className="flex flex-col gap-3">
            {info.entries.map((e) => (
              <div key={e.label} className="flex flex-col gap-1">
                <dt className="bm-label-l text-bm-ink">{e.label}</dt>
                <dd className="bm-body-m text-bm-muted">{e.text}</dd>
              </div>
            ))}
          </dl>
        )}
      </div>
    </BmModal>
  );
};

// The (i) beside a metric card's title ("About CacheScore") and the
// description it opens. Shown on every card, with or without a CacheValue
// in context.
const MetricInfo = ({ metric, onContext }) => {
  const [open, setOpen] = useState(false);
  if (!METRIC_INFO[metric]) return null;
  return (
    <>
      <InfoDot onClick={() => setOpen(true)} label={metricInfoLabel(metric)} />
      {open && <MetricInfoDialog metric={metric} onClose={() => setOpen(false)} onContext={onContext} />}
    </>
  );
};

export default MetricInfo;
